import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { HelperService } from '../shared/services/helper_service';
import { AuthService } from '../shared/services/auth_service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(public helperService: HelperService,private router: Router,  private authService: AuthService,) {
    console.log("Entering Error interceptors");
    
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError(err => {
      console.log("Interceptor error",err);
      
      let error = err.error.detail || err.error.message || err.statusText;

      // if (err["Status Code"] === 401) {
      //     // auto logout if 401 response returned from api
      //     // this.authService.logout();
      //     error = error == 'Invalid Token!' ? 'Your session expired!!' : error;
      //     this.helperService.presentToast(`ERROR: ${error}`);
      //     // location.reload();
      //     this.logout()
      // }

    //   if (err.error.errors) {
    //     for (const e of err.error.errors) {
    //         this.helperService.presentToast(e.msg || e.message);
    //     }
    //   }

      if (err["Status Code"] === 403) {
        this.helperService.presentToast(`Something went wrong, please try re-login!!`);
        this.logout()
      }

      return throwError(err);
    }));
  }
  logout() {
    console.log("User logged out!");
    this.authService.logout();
  }
}
